import React from 'react';
import { style } from 'typestyle';
import { useTranslation } from 'react-i18next';
import * as listStyles from '../../../core/admin-list.styles';
import type Facility from '../models/facility';
import getIconFromFacilityTypeEnum
  from '../../facility-types/utils/facility-type-enum-to-icon-mapper';
import { accentForFacilityType, facilityTypeLabelKey } from '../facility-type-appearance';

interface Props {
  readonly facility: Facility;
}

// Type tile + name + type label: the part of a facility that looks the same everywhere it is
// listed (editable rows and cards, and the read-only office tab).
const FacilityIdentity = ({ facility }: Props): React.JSX.Element => {
  const { t } = useTranslation();

  return (
    <>
      <div className={style(listStyles.rowTile(accentForFacilityType(facility.type)))}>
        {getIconFromFacilityTypeEnum(facility.type)}
      </div>
      <div className={style(listStyles.rowWho)}>
        <span className={style(listStyles.rowName)} title={facility.name}>
          {facility.name}
        </span>
        <span className={style(listStyles.rowSub)}>{t(facilityTypeLabelKey(facility.type))}</span>
      </div>
    </>
  );
};

export default FacilityIdentity;
